import { Injectable } from '@angular/core';
import { Router, NavigationStart } from '@angular/router';

@Injectable({
  providedIn: 'root',
})
export class RouteTrackingService {
  private previousUrl: string = '';
  private currentUrl: string = '';

  constructor(private router: Router) {
   
  }
  public setPreviousUrl(url: string): void {
    this.previousUrl = url;
    localStorage.setItem('previousUrl', url);
  }
  public getPreviousUrl(): string {
   
    return this.previousUrl;
  }
}
